import React from "react";
import { VimeoItem } from "../Works";

interface WorkListProps {
    workList: VimeoItem[];
    setShowModal: (show: boolean) => void;
    setShowItem: (item: VimeoItem) => void;
}

const WorkBlock: React.FC<WorkListProps> = ({
    workList,
    setShowModal,
    setShowItem,
}) => {
    return (
        <div className="works-list">
            {workList.map((item) => (
                <div
                    key={item.id}
                    className="works-card"
                    style={{
                        backgroundImage: `url(${item.thumbnail_large})`,
                    }}
                    onClick={() => {
                        setShowModal(true);
                        setShowItem(item);
                    }}
                >
                    <h3 className="works-card__title">
                        {item.title}
                    </h3>
                </div>
            ))}
        </div>
    );
};

export default WorkBlock;
